import React from 'react';
import { VStack, Center, HStack, Image as NativeImage, Box } from 'native-base';
import { Caption } from '~/shared/Typography';
import { SpIcon } from '~/shared/Icon';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { resizedUrl, useSpringBigStore, useTheme } from '@springbig/shared';
import { FullScreenBox } from '~/shared/Theme';

type AuthTemplateProps = {
    body: React.ReactNode;
};

export const AuthTemplate = ({
    body,
}: AuthTemplateProps) => {

    const {
        menu_background_primary,
        menu_text,
        radius_md,
        background_primary,
        background,
        radius_lg,
        header,
        text,
    } = useTheme();

    const {
        merchantName,
        tendlcLogoSrc,
    } = useSpringBigStore();

    return (
        <FullScreenBox>
            <HStack
                px={4}
                h={'60px'}
                w={'100%'}
                alignItems={'center'}
                justifyContent={'space-between'}
                backgroundColor={menu_background_primary}
            >
                <VStack space={1}>
                    { merchantName && merchantName !== 'null' &&
                        <Caption
                            color={menu_text}
                            text={'authTemplate.welcome'}
                            textValues={[merchantName]}
                            fontSize={18}
                            fontWeight={'light'}
                            lineHeight={'1em'}
                        />
                    }
                    <Caption
                        color={menu_text}
                        text={'authTemplate.log_in'}
                        fontSize={18}
                        bold
                        lineHeight={'1em'}
                    />
                </VStack>
                <SpIcon icon={faLock} color={menu_text} size={20} />
            </HStack>
            <Box
                bg={header}
                color={text}
                flex={1}
            >
                <Box
                    w={'100%'}
                    h={'100%'}
                    bg={background_primary}
                    roundedTop={0}
                >
                    { background && background.url &&
                        <NativeImage
                            source={{ uri: resizedUrl(background.url, 1000, 480) }}
                            position={'absolute'}
                            resizeMode={'cover'}
                            top={0}
                            bottom={0}
                            left={0}
                            roundedTop={radius_lg}
                            w={'clamp(320px, 100vw, 480px)'}
                        />
                    }
                    <Box
                        w={'clamp(320px, 100vw, 480px)'}
                        roundedTop={radius_lg}
                        overflowX={'clip'}
                        overflowY={'auto'}
                        flex={1}
                    >
                        <Center py={4}>
                            { tendlcLogoSrc ?
                                <NativeImage
                                    resizeMode={'cover'}
                                    rounded={radius_md}
                                    w={160}
                                    h={160}
                                    src={tendlcLogoSrc}
                                /> :
                                <Box
                                    rounded={radius_md}
                                    w={160}
                                    h={160}
                                ></Box>
                            }
                        </Center>
                        { body }
                    </Box>
                </Box>
            </Box>
        </FullScreenBox>
    );
};
